import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  type ButtonProps,
} from '@chakra-ui/react';

import { ActionButton } from './FormModalWrapperActionButton';
import { testIds } from './testIds';

type ModalWrapperPropTypes = {
  modalOpenButtonText?: string | React.ReactNode;
  modalOpenButtonLeftIcon?: React.ElementType;
  modalContent: React.ReactNode;
  isOpen: boolean;
  onClose: () => void;
  onOpen?: () => void;
  modalContentHeight?: string;
  bgColor?: string;
  modalOpenButtonVariant?: 'primary' | 'secondary' | 'outline';
  modalCloseButton?: boolean;
  modalOpenButtonTestId?: string;
  modalOpenButtonDisabled?: boolean;
  modalOpenButtonProps?: ButtonProps; // ✅ extra button props
  size?: string;
};

// ...ActionButton logic moved to FormModalWrapperActionButton.tsx...

/**
 * A modal wrapper component specifically designed for form interactions.
 */
export function FormModalWrapper({
  modalOpenButtonText,
  modalOpenButtonLeftIcon,
  modalContent,
  isOpen,
  onClose,
  onOpen,
  modalContentHeight = '500px',
  bgColor = 'bg.surface',
  modalOpenButtonVariant = 'primary',
  modalCloseButton = true,
  modalOpenButtonTestId,
  modalOpenButtonDisabled = false,
  modalOpenButtonProps,
  size = '3xl',
}: ModalWrapperPropTypes): React.ReactElement {
  return (
    <>
      {modalOpenButtonText != null && onOpen != null ? (
        <ActionButton
          modalOpenButtonText={modalOpenButtonText}
          modalOpenButtonLeftIcon={modalOpenButtonLeftIcon}
          modalOpenButtonVariant={modalOpenButtonVariant}
          onOpen={onOpen}
          modalOpenButtonTestId={modalOpenButtonTestId}
          isDisabled={modalOpenButtonDisabled}
          {...modalOpenButtonProps}
        />
      ) : null}

      <Modal
        onClose={onClose}
        isOpen={isOpen}
        isCentered
        closeOnOverlayClick={false}
        size={size}
        data-testid={testIds.FormModalWrapper}
      >
        <ModalOverlay />
        <ModalContent h={modalContentHeight} bg={bgColor}>
          <ModalHeader></ModalHeader>
          {modalCloseButton ? <ModalCloseButton size="xs" /> : null}
          <ModalBody h="full" p="0px" m="0px">
            {modalContent}
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
}
